import auth from './auth.duck';
import members from './members.duck';
import accounts from './accounts.duck';
import countries from './countries.duck';
import notification from './notification.duck';
import structure from './structure.duck';
import organization from './organization.duck';
import results from './results.duck';
import duplicateOibMembers from './duplicate-oibs.duck';
import payments from './payments.duck';
import bulkMails from './bulkMails.duck';

export default {
  auth,
  members,
  accounts,
  countries,
  notification,
  structure,
  organization,
  results,
  duplicateOibMembers,
  payments,
  bulkMails,
};
